import { Currency } from "@/types/types"

const CurrencyIcon = ({ src }: { src: Currency["logo_url"] }) => (
  <div className="flex size-6 items-center justify-center overflow-hidden rounded-full lg:size-8">
    {src && <img src={src} className="size-full" />}
  </div>
)

export default CurrencyIcon
